(ns client-portal.client.conversations.list.views
  (:require [client-portal.client.anonymous.data :as anon.d]
            [client-portal.client.layout :as l]
            [client-portal.client.conversations.list.data :as list.d]
            [client-portal.client.conversations.individual.views]
            [client-portal.client.conversations.individual.data :as conversation.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            [shared.core.components.components :as c]
            [shared.core.style :as style]
            [shared.core.time :as time]
            [cljs-time.coerce :as t.coerce]
            [clojure.string :as s]))

(defn no-conversation-details-label [{:keys [label style]}]
  [:span {:style (merge {:color (style/color :on-background :base)
                         :opacity 0.5}
                        style)}
   label])

(defn conversations-list [{:keys [list-loading? flattened-list-data franchise-group-data has-more-data?
                                  list-next-page-loading? list-next-page last-selected-id anon-ctx]}]
  [c/primary-table
   {:no-data-text (when-not list-loading? "No Conversations Available")
    :virtual-scroll-container-id "with-header-nav-scroll-panel"
    :loading-more? list-next-page-loading?
    :loading? (or list-loading? (not franchise-group-data))
    :row-height 108
    :bottom-row-buffer 20
    :on-bottom-buffer (when has-more-data?
                        #(re/dispatch [:conversations/load-list-data [nil {:page list-next-page}]]))
    :rows (map-indexed
            (fn [idx {:keys [conversation-id] :as conv}]
              (let [last-row? (and (not has-more-data?) (= idx (dec (count flattened-list-data))))
                    {:keys [location-name+brand-id location-city-state franchise-group-label
                            phone-call-timestamp-formatted]}
                    (conversation.d/with-display-details conv franchise-group-data anon-ctx)]
                {:cells [[:div {:style {:display :flex
                                        :align-items :center
                                        :position :relative
                                        :width "100%"}}
                          [:div {:style {:display :flex
                                         :flex-direction :column}}
                           [:span {:style {:color (style/color :primary :base)
                                           :font-size 17
                                           :font-weight style/font-extra-bold-weight
                                           :margin-bottom 2}}
                            location-name+brand-id]
                           (if location-city-state
                             [:span {:style {:margin-top 3}}
                              location-city-state]
                             [no-conversation-details-label {:label "No Location Details"
                                                             :style {:margin-top 3}}])
                           (if franchise-group-label
                             [:span {:style {:margin-top 3}}
                              franchise-group-label]
                             [no-conversation-details-label {:label "No Franchise Group"
                                                             :style {:margin-top 3}}])
                           (if phone-call-timestamp-formatted
                             [:span {:style {:margin-top 3}}
                              phone-call-timestamp-formatted]
                             [no-conversation-details-label {:label "No Call Time"
                                                             :style {:margin-top 3}}])]
                          (when (= last-selected-id conversation-id)
                            [:div {:style {:color (style/color :primary :base)
                                           :font-size 11
                                           :font-weight style/font-extra-bold-weight
                                           :letter-spacing "1px"
                                           :text-transform :uppercase
                                           :position :absolute
                                           :top 0
                                           :right 10}}
                             "Last Viewed"])]]
                 :style (when last-row?
                          {:border-bottom :none})
                 :actions [{:icon-type :pin
                            :on-click #(re/dispatch-sync [:core/copy-to-clipboard conversation-id {:notify? true}])
                            :tooltip-content "Copy Conversation ID"}
                           {:icon-type :phone-in-talk
                            :on-click #(re/dispatch [:conversations/open conversation-id])
                            :tooltip-content "Open Conversation"}]
                 :on-click #(re/dispatch [:conversations/open conversation-id])}))
            (util/when-not-loading flattened-list-data))}])

(defn conversations-controls [_]
  (let [scroll-position- (re/subscribe [:core/layout-content-container-scroll-position-])
        start-date-time- (re/subscribe [:form/val- list.d/filters-path :start-date-time])
        end-date-time- (re/subscribe [:form/val- list.d/filters-path :end-date-time])
        franchise-group-cohort-id- (re/subscribe [:form/val- list.d/filters-path :franchise-group-cohort-id])
        filters- (re/subscribe [:form/form- list.d/filters-path])
        location-id- (re/subscribe [:form/val- list.d/filters-path :location-id])
        query-params- (re/subscribe [:router/current-query-params-])
        potential-query-params- (re/subscribe [:conversations/filter-values-as-query-params-])]
    (fn [{:keys [franchise-group-data locations-data anon-ctx]}]
      (let [js-now (js/Date.)
            js-midnight-today (.setHours (js/Date.) 0 0 0 0)
            start-date-time-js (some-> @start-date-time- (time/from-string) (t.coerce/to-date))
            end-date-time-js (some-> @end-date-time- (time/from-string) (t.coerce/to-date))
            dates-same? (fn [d1 d2]
                          (let [d1-mn (.setHours (js/Date. d1) 0 0 0 0)
                                d2-mn (.setHours (js/Date. d2) 0 0 0 0)]
                            (= d1-mn d2-mn)))
            start-date-time-js-end-of-day (some-> start-date-time-js
                                                  (js/Date.)
                                                  (.setHours 23 59 0 0))
            same-date? (and start-date-time-js end-date-time-js (dates-same? start-date-time-js end-date-time-js))
            params-same? (and (every? #(= (get @query-params- %) (get @potential-query-params- %))
                                      (keys @potential-query-params-))
                              (not (and (empty? @potential-query-params-) (not-empty @query-params-))))
            sel-franchise-group-id (some-> @franchise-group-cohort-id- (util/parse-int))
            sel-location-id (some-> @location-id- (util/parse-int))
            filters-to-clear? (some->> @filters-
                                       (filter (fn [[_ v]]
                                                 (and v (or (not (string? v)) (not (s/blank? v))))))
                                       (count)
                                       (pos?))]
        [:div {:style (cond-> {:background-color (style/color :background :base)
                               :display :flex
                               :align-items :flex-end
                               :margin-bottom 10
                               :padding "10px 0"
                               :position :sticky
                               :top 0
                               :left 0
                               :z-index (style/z :medium)}
                              (>= @scroll-position- 95)
                              (assoc :border-bottom (str "1px solid " (style/color :gray :shade-7))))}
         [:div {:style {:flex "0 1 220px"}}
          [c/primary-label {} "Start Date"]
          [c/primary-date-picker (cond-> {:form-path list.d/filters-path
                                          :form-name :start-date-time
                                          :show-time? true
                                          :clearable? true
                                          :max-date js-now}

                                         end-date-time-js
                                         (assoc :max-date end-date-time-js)

                                         (and end-date-time-js same-date?)
                                         (assoc :min-time (.setHours (js/Date. end-date-time-js) 0 0 0 0)
                                                :max-time end-date-time-js)

                                         (and (not end-date-time-js)
                                              (or (not start-date-time-js) (dates-same? js-now start-date-time-js)))
                                         (assoc :max-date js-now
                                                :min-time js-midnight-today
                                                :max-time js-now))]]
         [:div {:style {:flex "0 1 220px"
                        :margin-left 10}}
          [c/primary-label {} "End Date"]
          [c/primary-date-picker (cond-> {:form-path list.d/filters-path
                                          :form-name :end-date-time
                                          :show-time? true
                                          :clearable? true
                                          :max-date js-now}

                                         (or (and (not start-date-time-js) (not end-date-time-js))
                                             (and end-date-time-js (dates-same? js-now end-date-time-js)))
                                         (assoc :max-date js-now
                                                :min-time js-midnight-today
                                                :max-time js-now)

                                         start-date-time-js
                                         (assoc :min-date start-date-time-js)

                                         (and start-date-time-js same-date?)
                                         (assoc :max-time (if (> start-date-time-js-end-of-day js-now)
                                                            js-now
                                                            start-date-time-js-end-of-day)
                                                :min-time start-date-time-js))]]
         [c/primary-dropdown (cond-> {:form-path list.d/filters-path
                                      :form-name :franchise-group-cohort-id
                                      :options (if (util/loading? franchise-group-data)
                                                 :loading
                                                 (mapv (fn [{:keys [id label]}]
                                                         {:text label
                                                          :value id})
                                                       franchise-group-data))
                                      :sort-by-text? true
                                      :clearable? true
                                      :label "Franchise Group"
                                      :container-style {:flex "0 1 200px"
                                                        :margin-left 10}}
                                     sel-location-id
                                     (assoc :disabled? true))]
         [c/primary-dropdown {:form-path list.d/filters-path
                              :form-name :location-id
                              :options (if (util/loading? franchise-group-data)
                                         :loading
                                         (->> locations-data
                                              (#(if sel-franchise-group-id
                                                  (filter (fn [{:keys [franchise-group-cohort-id]}]
                                                            (= franchise-group-cohort-id sel-franchise-group-id))
                                                          %)
                                                  %))
                                              (map (fn [{:keys [id brand-id label]}]
                                                     {:text (str (anon.d/location-label anon-ctx label) " (" brand-id ")")
                                                      :value id}))))
                              :sort-by-text? true
                              :clearable? true
                              :label "Store"
                              :container-style {:flex "0 1 300px"
                                                :margin-left 10}}]
         [c/primary-button {:style {:margin-left 10}
                            :disabled? params-same?
                            :on-click #(re/dispatch [:conversations/apply-list-filters])}
          "Search"]
         #_(when filters-to-clear?
             [c/primary-a {:on-click #(do
                                        (re/dispatch [:form/reset list.d/filters-path])
                                        (re/dispatch [:conversations/apply-list-filters]))
                           :style {:margin-bottom 6
                                   :margin-left 10}}
              "Clear Filters"])]))))

(defn conversation-id-search []
  (let [val @(re/subscribe [:form/val- list.d/root-path :conversation-id])]
    [c/primary-input {:form-path list.d/root-path
                      :form-name :conversation-id
                      :label "Conversation ID"
                      :placeholder "Paste Conversation ID"
                      :container-style {:flex "0 1 180px"}
                      :on-key-down #(when (util/enter-key-event? %)
                                      (re/dispatch [:conversations/open-input-conversation-id]))
                      :on-paste #(let [text (.getData (.-clipboardData %) "text")]
                                   (util/wait 100 (fn []
                                                    (re/dispatch [:conversations/open-input-conversation-id
                                                                  {:conversation-id text}]))))}]))

(defn conversations-list-root [_]
  (let [list-data- (re/subscribe [:conversations/list-data-])
        list-loading?- (re/subscribe [:conversations/list-loading?-])
        list-next-page-loading?- (re/subscribe [:conversations/list-next-page-loading?-])
        list-next-page- (re/subscribe [:conversations/list-next-page-])
        flattened-list-data- (re/subscribe [:conversations/list-data-flattened-])
        has-more-data?- (re/subscribe [:conversations/list-data-has-more?-])
        franchise-groups-data- (re/subscribe [:cohorts/franchise-groups-data-])
        franchise-groups-data-keyed- (re/subscribe [:cohorts/franchise-groups-data-keyed-])
        locations- (re/subscribe [:locations/by-current-concept-id-])
        anon-ctx- (re/subscribe [:anonymous/ctx-])
        last-selected-id- (re/subscribe [:conversations/list-last-selected-id-])
        concept-id- (re/subscribe [:concepts/current-concept-id-])
        modal- (re/subscribe [:modals/active-])
        handle-conv-modal (fn [this]
                            (let [{:keys [conv-id]} (re/props this)]
                              (when (and conv-id (not @modal-))
                                (re/dispatch [:modals/show [:conversations/conversation-modal
                                                            {:background-click #(re/dispatch [:conversations/close])
                                                             :conversation (or (some->> (util/when-not-loading @flattened-list-data-)
                                                                                        (filter #(= (:conversation-id %) conv-id))
                                                                                        (first))
                                                                               {:conversation-id conv-id})}]]))))]
    (re/create-class
      {:component-did-mount
       #(do
          (re/dispatch [:conversations/set-default-start-date])
          (re/dispatch [:conversations/initialize])
          (re/dispatch [:conversations/set-initial-filters])
          (handle-conv-modal %))

       :component-did-update
       handle-conv-modal

       :reagent-render
       (fn [args]
         [l/logged-in-with-header-nav (merge args
                                             {:page-header-contents [[c/spacer]
                                                                     (when @concept-id-
                                                                       [conversation-id-search])]
                                              :data-loading? (and @concept-id-
                                                                  (or (util/loading? @franchise-groups-data-)
                                                                      (util/loading? @locations-)))
                                              :concept-dropdown? true})
          (when @concept-id-
            [conversations-controls {:franchise-group-data @franchise-groups-data-
                                     :locations-data @locations-
                                     :anon-ctx @anon-ctx-}])
          (if @concept-id-
            [conversations-list {:list-data @list-data-
                                 :list-loading? @list-loading?-
                                 :list-next-page-loading? @list-next-page-loading?-
                                 :list-next-page @list-next-page-
                                 :last-selected-id @last-selected-id-
                                 :flattened-list-data @flattened-list-data-
                                 :has-more-data? @has-more-data?-
                                 :franchise-group-data @franchise-groups-data-keyed-
                                 :anon-ctx @anon-ctx-}]
            [l/message-section "No Concept Selected"])])})))
